import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  MenuSelectors,
  UserContextSelectors
} from "../../redux/selectors/index.js";
import { MenuActionCreators } from "../../redux/action-creators/index.js";
import { SportCategoryMenuItem } from "../Menu/SportCategoryMenuItem.js";
import { useClickOutside } from "../../hooks/index.js";
import classNames from "classnames";
import InnerMenuHeader from "../Menu/Categories/InnerMenuHeader.js";
import MenuItemList from "../Menu/Categories/MenuItemList.js";
import { SportAZMenuWrapper } from "./components/SportAZMenuWrapper.js";

const SportAZMenu = props => {
  const { item, dataTestId } = props;

  const [title, setTitle] = useState("");

  useEffect(() => {
    const kambiTitle = item?.title?.defaultMessage;
    const innerMenuHeaderProps = kambiTitle ? kambiTitle : item.title;
    setTitle(innerMenuHeaderProps);
  }, [item.title]);

  const ignoreClass = `do-not-close-${dataTestId}`;

  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );
  const quickLinksInnerMenuItem = useSelector(
    MenuSelectors.quickLinksInnerMenuItem
  );
  const favouriteSportsRunningInsideInnerMenu = useSelector(
    MenuSelectors.favouriteSportsRunningInsideInnerMenu
  );
  const isMobile = useSelector(UserContextSelectors.isMobile);

  const dispatch = useDispatch();

  const onItemClick = () => {
    dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
    dispatch(
      MenuActionCreators.setFavouriteSportsRunningInsideInnerMenu(false)
    );
  };

  const currentRef = useClickOutside(
    () => {
      dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
      dispatch(
        MenuActionCreators.setFavouriteSportsRunningInsideInnerMenu(false)
      );
    },
    {
      ignoreClass: ["generic-drawer", ignoreClass],
      disabled: !(
        (quickLinksInnerMenuVisible && item === quickLinksInnerMenuItem) ||
        favouriteSportsRunningInsideInnerMenu
      )
    }
  );

  const menuClasses = useMemo(
    () =>
      classNames({
        "sub-menu": !isMobile,
        "drawer-show-left":
          (quickLinksInnerMenuVisible ||
            favouriteSportsRunningInsideInnerMenu) &&
          quickLinksInnerMenuItem === item,
        [ignoreClass]: !!ignoreClass
      }),
    [
      isMobile,
      quickLinksInnerMenuVisible,
      favouriteSportsRunningInsideInnerMenu,
      quickLinksInnerMenuItem,
      item,
      ignoreClass
    ]
  );

  return (
    <SportAZMenuWrapper
      className={menuClasses}
      ref={currentRef}
      data-testid={"uc-sport-az-menu"}
    >
      {!isMobile && <InnerMenuHeader title={title} />}
      <MenuItemList
        items={item.items}
        component={SportCategoryMenuItem}
        termKeyPrefix={item.termKeyPrefix}
        onClick={onItemClick}
      />
    </SportAZMenuWrapper>
  );
};

SportAZMenu.propTypes = {
  item: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
};

export default React.memo(SportAZMenu);
